<template>
  <div v-loading="loading" :element-loading-text="loadingText" class="home-container animate__animated animate__fadeIn">
    <div class="out-container">
      <div class="hexagon-box1">
        <div class="hexagon" v-for="item in cardList.slice(0, 2)" :key="item.id" @click="enterBussinss(item)">
          <strong class="hexagon-text">{{ item.title }}</strong>
        </div>
      </div>
      <div class="hexagon-box2">
        <div class="hexagon" v-for="item in cardList.slice(2, 4)" :key="item.id" @click="enterBussinss(item)">
          <strong class="hexagon-text">{{ item.title }}</strong>
        </div>
      </div>
      <div class="hexagon-box3">
        <div class="hexagon" v-for="item in cardList.slice(4, 7)" :key="item.id" @click="enterBussinss(item)">
          <strong class="hexagon-text">{{ item.title }}</strong>
        </div>
      </div>
      <div class="hexagon-box4">
        <div class="hexagon" v-for="item in cardList.slice(7, 9)" :key="item.id" @click="enterBussinss(item)">
          <strong class="hexagon-text">{{ item.title }}</strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import microApps from "../../micro-app";
// import { loadMicroApp } from "qiankun"; // 引入 qiankun 相关 API

export default {
  name: "MyComponent",
  data() {
    return {
      message: "Hello World",
      cardList: [
        {
          id: "007",
          title: "隧道2C",
          app: "vue-tunnel-2c"
        },
        {
          id: "005",
          title: "5C系统",
          app: "vue-admin-5c"
        },
        {
          id: "009",
          title: "简易1C",
          app: "vue-simple-1c"
        },
        {
          id: "003",
          title: "3C系统",
          app: "vue-admin-3c"
        },
        {
          id: "008",
          title: "简易4C",
          app: "vue-simple-4c"
        },
        {
          id: "002",
          title: "2C系统",
          app: "vue-admin-2c"
        },
        {
          id: "006",
          title: "浮冰监测",
          app: "vue-floating-ice"
        },

        {
          id: "001",
          title: "1C系统",
          app: "vue-admin-1c"
        },
        {
          id: "004",
          title: "4C系统",
          app: "vue-admin-4c"
        },
      ],
      activeApp: "",
      loading: false,
      loadingText: ""
    };
  },

  methods: {
    // 点击卡片时加载子应用
    enterBussinss(item) {
      // // 1. 点击卡片时立刻显示loading
      // this.loading = true;
      // this.loadingText = `正在进入 ${item.title}，请稍等...`;

      // // 2. 使用 setTimeout 模拟加载延迟
      // setTimeout(() => {

      // }, 1500); // 延迟 2 秒
      // 3. 延迟 2 秒后进入子应用
      this.activeApp = item.app;
      // 查找对应的子应用配置
      const app = microApps.find(app => app.name === item.app);
      if (app) {
        // 创建一个 a 标签
        const link = document.createElement("a");
        // 拼接完整的URL
        link.href = app.entry.startsWith("http")
          ? app.entry
          : "http:" + app.entry;
        link.target = "_self"; // 在当前窗口打开链接（可以根据需要更改）
        document.body.appendChild(link); // 将链接添加到文档中
        link.click(); // 触发点击事件，跳转到新的地址
        document.body.removeChild(link); // 跳转后移除链接
        // this.loading = false;
        // loadMicroApp(app);
        // localStorage.setItem("appData", JSON.stringify(item));
      }
    }
  }
};
</script>

<style lang="less" scoped>
* {
  margin: 0;
}

/* Your styles here */
.page-content {
  justify-content: space-around;
  height: calc(100% - 30px);
  // gap: 30px;
  padding: 20px;
  box-sizing: border-box;

  .el-card {
    width: 20%;
    transition: all 0.3s ease;
    /* 为卡片增加平滑的过渡效果 */
    margin: 0 10px;

    /* 初始卡片样式 */
    background-color: #fff;
    /* 卡片的初始背景色 */
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    /* 初始阴影 */
    color: #333;
    /* 初始字体颜色 */
    padding: 20px;
    border-radius: 8px;
    /* 可选的圆角效果 */

    /* 鼠标悬浮时的效果 */
    &:hover {
      background-color: #f1f1f1;
      /* 背景颜色加深 */
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
      /* 阴影效果加深 */
      color: #000;
      /* 字体颜色加深 */
      cursor: pointer;
    }
  }
}

#subapp-viewport {
  width: 100%;
}

.home-container {
  height: 99%;
  background-image: url("../../assets/homebg.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  /* 使得子元素可以使用绝对定位 */
  display: flex;
  justify-content: flex-end;
  gap: 2%;

  .itembox {
    width: 200px;
    height: 100%;
    // background: pink;
  }
}

.out-container {
  position: relative;
  /* 让子元素可以绝对定位 */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  height: 91%;
  /* 使容器高度占满整个屏幕 */
  overflow: hidden;
  /* 防止出现滚动条 */
  margin: 2% auto;
}

.hexagon-box1 {
  position: relative;
  // flex: 0 0 25%; /* 让第一个盒子占据 25% 高度，固定不动 */
  flex: 1;
  display: flex;
  justify-content: flex-end;
  padding: 5% 5.5% 0 0;
  box-sizing: border-box;
  gap: 23.6%;
}

.hexagon-box2 {
  position: relative;
  flex: 1;
  /* 让剩余的盒子占据剩下的空间 */
  display: flex;
  justify-content: flex-end;
  gap: 29.5%;
  padding: 0% 20.5% 0% 0;
}

.hexagon-box3 {
  position: relative;
  flex: 1;
  /* 让剩余的盒子占据剩下的空间 */
  display: flex;
  justify-content: flex-end;
  gap: 23.5%;
  padding: 0 5% 0% 0;
  box-sizing: border-box;

  .hexagon:nth-child(2) {
    position: relative !important;
    right: 10px !important;
  }
}

.hexagon-box4 {
  position: relative;
  flex: 1;
  /* 让剩余的盒子占据剩下的空间 */
  display: flex;
  justify-content: flex-end;
  gap: 29.5%;
  padding: 0 20.5% 5% 0;
}

.hexagon {
  // background: pink;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transform: rotate(29.5deg) scale(2);
  /* 放大 hexagon，但不影响里面的文字 */
}

.hexagon-text {
  transform: rotate(-29.5deg) scale(0.5);
  /* 文字不受缩放影响 */
  font-size: 2vw;
  font-weight: 900;
  color: #1925c7;
  letter-spacing: 2px;
}
</style>